document.addEventListener('DOMContentLoaded', () => {

  const canvas = document.getElementById("pictures_frames");
  const context = canvas ? canvas.getContext("2d") : null;

  const wrapper = document.querySelector("[data-pictures-array]");
  let picturesArray = [];

  if (wrapper && wrapper.dataset.picturesArray) {
    try {
      picturesArray = JSON.parse(wrapper.dataset.picturesArray) || [];
    } catch (e) {
      console.warn('Erro ao fazer parse de data-pictures-array:', e);
      picturesArray = [];
    }
  }

  const frames = {
    currentIndex: 0,
    maxIndex: picturesArray.length ? picturesArray.length - 1 : 0
  }

  let imgsLoad = 0;
  const imgs = [];

  const preloadImages = () => {
    picturesArray.forEach((url, i) => {
      const img = new Image();
      if (url.startsWith("//")) {
        img.src = "https:" + url;
      } else {
        img.src = url;
      }

      img.onload = () => {
        imgsLoad++;
        if (i === 0) {
          loadImage(0);
        }

        if (imgsLoad === picturesArray.length) {
          console.log("Imagens carregadas");

          // atualiza maxIndex baseado nas imagens carregadas
          frames.maxIndex = Math.max(0, imgs.length - 1);

          // desenha frame atual
          loadImage(Math.floor(frames.currentIndex));

          // chama reinit geral forçando a inicialização correta
          if (typeof reinitAnimations === 'function') {
            reinitAnimations({ force: true });
          } else {
            // fallback se por algum motivo não existir: decide manualmente
            if (window.innerWidth >= 1080 && typeof startAnimation === 'function') startAnimation();
            else if (typeof startAnimationMobile === 'function') {
              startAnimationMobile();
              if (typeof initMobileCanvasAnimation === 'function') initMobileCanvasAnimation();
            }
          }
        }
      };

      img.onerror = () => {
        console.warn("Erro ao carregar imagem:", img.src);
      };

      imgs.push(img);
    });
  };

  const loadImage = (index) => {
    if (!canvas || !context) return;

    // corrige índices inválidos – permite desenhar fallback se necessário
    if (typeof index !== 'number') index = Math.floor(frames.currentIndex || 0);
    if (index < 0) index = 0;

    // atualiza frames.maxIndex se imgs mudou
    frames.maxIndex = Math.max(0, imgs.length - 1);

    // se índice maior que maxIndex, usa fallback índice 0
    if (index > frames.maxIndex) index = 0;

    const img = imgs[index];
    // fallback se não houver imagem válida
    if (!img || !img.width || !img.height) {
      const fallback = imgs[0];
      if (!fallback || !fallback.width || !fallback.height) return;
      frames.currentIndex = 0;
      const draw = (source) => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        const scaleX = canvas.width / source.width;
        const scaleY = canvas.height / source.height;
        const scale = Math.min(scaleX, scaleY);
        const newWidth = source.width * scale;
        const newHeight = source.height * scale;
        const offsetX = (canvas.width - newWidth) / 2;
        const offsetY = (canvas.height - newHeight) / 2;
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = "high";
        context.drawImage(source, offsetX, offsetY, newWidth, newHeight);
      };
      draw(fallback);
      return;
    }

    // calcula dimensões e offsets conforme breakpoints 
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const scaleX = canvas.width / img.width;
    const scaleY = canvas.height / img.height;
    const scale = Math.min(scaleX, scaleY);

    const newWidth = img.width * scale;
    const newHeight = img.height * scale;

    let offsetX, offsetY;

    if (window.innerWidth >= 1080) {
      offsetX = (canvas.width - newWidth) / 2;
      offsetY = (canvas.height - newHeight) / 2;
    } else if (window.innerWidth < 1080 && window.innerWidth >= 768) {
      offsetX = (canvas.width - newWidth) / 3;
      offsetY = (canvas.height - newHeight) / 3;
    } else {
      offsetX = (canvas.width - newWidth) / 2;
      offsetY = (canvas.height - newHeight) / 2;
    }

    context.clearRect(0, 0, canvas.width, canvas.height);
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    context.drawImage(img, offsetX, offsetY, newWidth, newHeight);

    frames.currentIndex = index;
  }

  const startAnimation = () => {

    let informativesEnd = {
      rotation: 35,
      xPercent: 0,
      yPercent: 0,
      scale: 1.1
    };

    let wineEnd = {
      rotation: -10,
      xPercent: 0,
      yPercent: 0,
      scale: 1.25
    };

    informativesEnd = {
      xPercent: window.innerHeight < 950 ? 40 : window.innerHeight < 1100 ? 60 : 50,
      yPercent: 30,
      rotation: 35,
      scale: window.innerHeight < 950 ? 1.35 : 1.45
    };

    wineEnd = {
      xPercent: window.innerHeight < 950 ? 25 : window.innerHeight < 1100 ? 40 : 30,
      yPercent: 20,
      rotation: -10,
      scale: 1.35
    };

    // --- 1) informatives ---
    let tl_informatives = gsap.timeline({
      scrollTrigger: {
        trigger: ".informatives_product--content",
        start: "top 100%",
        end: "top -30%",
        scrub: 1,
      }
    });

    tl_informatives.set(".pictures_frames--canvas", {
      transformOrigin: "50% 50%",
      xPercent: 0,
      yPercent: 10,
      rotation: 0,
      scale: 1.15
    });

    tl_informatives
      .to(".pictures_frames--canvas", {
        rotation: informativesEnd.rotation,
        xPercent: informativesEnd.xPercent,
        yPercent: informativesEnd.yPercent,
        scale: informativesEnd.scale,
        ease: "none",
        willChange: "transform"
      }, 'a')
      .to(frames, {
        currentIndex: frames.maxIndex,
        onUpdate: () => loadImage(Math.floor(frames.currentIndex)),
        ease: "none",
        immediateRender: false
      }, 'a');

    // --- 2) wine ---
    let tl_wine = gsap.timeline({
      scrollTrigger: {
        trigger: ".informatives_product--content",
        start: "top -30%",
        end: "top -55%",
        scrub: 1,
      }
    });

    tl_wine
      .to(frames, {
        currentIndex: 0,
        onUpdate: () => loadImage(Math.floor(frames.currentIndex)),
        ease: "power1.inOut",
        immediateRender: false
      }, 'b')
      .to(".pictures_frames--canvas", {
        rotation: wineEnd.rotation,
        xPercent: wineEnd.xPercent,
        yPercent: wineEnd.yPercent,
        scale: wineEnd.scale,
        ease: "power1.inOut",
        willChange: "transform"
      }, 'b');

    // --- 3) canteen ---
    let tl_canteen = gsap.timeline({
      scrollTrigger: {
        trigger: "#product--canteen",
        start: "top 80%",
        end: "top 5%",
        scrub: 1,
      }
    });

    tl_canteen
      .set(".pictures_frames--canvas", {
        transformOrigin: "50% 50%",
        rotation: wineEnd.rotation,
        xPercent: wineEnd.xPercent,
        yPercent: wineEnd.yPercent,
        scale: wineEnd.scale,
        immediateRender: false
      })
      .set(frames, { currentIndex: 0, immediateRender: false })
      .to(frames, {
        currentIndex: frames.maxIndex,
        onUpdate: () => loadImage(Math.floor(frames.currentIndex)),
        ease: "none",
        immediateRender: false
      }, 'c')
      .to(".pictures_frames--canvas", {
        rotation: -90,
        xPercent: window.innerHeight < 950 ? 20 : window.innerHeight < 1100 ? 40 : 20,
        yPercent: window.innerHeight < 950 ? -10 : -5,
        scale: 1.7,
        ease: "none",
        willChange: "transform"
      }, 'c');
  };

  const startAnimationMobile = () => {
    if (startAnimationMobile._initted) return;
    startAnimationMobile._initted = true;

    const pictureCanvas = document.querySelector('.pictures_frames--canvas') || canvas;
    let startX = 0,
      startY = 0,
      lastX = 0,
      isDragging = false,
      touchId = null,
      startIndexAtTouch = 0,
      lastMoveTime = 0;

    const maxIndex = () => frames.maxIndex;

    // retorna largura de referência 
    const effectiveWidth = () => Math.min(window.innerWidth, 1080);

    // sensibilidade adaptativa
    const getDragSensitivity = () => {
      const w = window.innerWidth;
      if (w < 420) return 1.6;
      if (w < 768) return 1.6;
      if (w >= 768 && w < 1080) return 2.2;
      return 1.0;
    };

    // limiar adaptativo
    const getSwiperThreshold = () => {
      const w = window.innerWidth;
      if (w < 420) return 30;
      if (w >= 768 && w < 1080) return 28;
      return 40;
    };

    // converte deltaX em variação de índice (usa valores dinâmicos)
    const deltaXToIndexDelta = (deltaX) => {
      const norm = (deltaX / effectiveWidth()) * getDragSensitivity();
      return -norm * maxIndex();
    };

    const handlers = {};

    const onTouchStart = (e) => {
      // recalcula sensibilidade no início do toque
      const touch = e.changedTouches ? e.changedTouches[0] : e;
      touchId = touch.identifier ?? null;
      startX = touch.clientX;
      startY = touch.clientY;
      lastX = startX;
      isDragging = true;
      startIndexAtTouch = frames.currentIndex;
      lastMoveTime = performance.now();

      gsap.killTweensOf(frames);
    };

    const onTouchMove = (e) => {
      if (!isDragging) return;

      let touch = e.changedTouches ? Array.from(e.changedTouches).find(t => t.identifier === touchId) : e;
      if (!touch) return;

      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;

      if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 10) return;

      lastX = touch.clientX;
      lastMoveTime = performance.now();

      const indexDelta = deltaXToIndexDelta(deltaX);
      const newIndex = startIndexAtTouch + indexDelta;
      frames.currentIndex = Math.max(0, Math.min(maxIndex(), newIndex));

      loadImage(Math.floor(frames.currentIndex));
    };

    const onTouchEnd = (e) => {
      if (!isDragging) return;

      let touch = e.changedTouches ? Array.from(e.changedTouches).find(t => t.identifier === touchId) : e;
      const endX = touch ? touch.clientX : lastX;
      const deltaX = endX - startX;

      isDragging = false;
      touchId = null;

      const absDeltaX = Math.abs(deltaX);
      const swiperThreshold = getSwiperThreshold();

      let targetIndex;
      if (absDeltaX > swiperThreshold) {
        const indexDelta = deltaXToIndexDelta(deltaX);
        targetIndex = Math.round(startIndexAtTouch + indexDelta);
      } else {
        targetIndex = Math.round(frames.currentIndex);
      }

      targetIndex = Math.max(0, Math.min(maxIndex(), targetIndex));

      gsap.to(frames, {
        currentIndex: targetIndex,
        duration: 0.45,
        ease: "power2.out",
        onUpdate: () => loadImage(Math.floor(frames.currentIndex)),
        immediateRender: false
      });
    };

    const onMouseDown = (e) => {
      e.preventDefault();
      onTouchStart(e);
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    };
    const onMouseMove = (e) => onTouchMove(e);
    const onMouseUp = (e) => {
      onTouchEnd(e);
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };

    handlers.touchStart = onTouchStart;
    handlers.touchMove = onTouchMove;
    handlers.touchEnd = onTouchEnd;
    handlers.touchCancel = onTouchEnd;
    handlers.mouseDown = onMouseDown;
    handlers.mouseMove = onMouseMove;
    handlers.mouseUp = onMouseUp;
    handlers.resize = () => loadImage(Math.floor(frames.currentIndex));

    canvas.style.touchAction = "pan-y";
    canvas.addEventListener("touchstart", handlers.touchStart, { passive: true });
    canvas.addEventListener("touchmove", handlers.touchMove, { passive: true });
    canvas.addEventListener("touchend", handlers.touchEnd, { passive: true });
    canvas.addEventListener("touchcancel", handlers.touchCancel, { passive: true });
    canvas.addEventListener("mousedown", handlers.mouseDown, { passive: false });

    window.addEventListener("resize", handlers.resize);

    startAnimationMobile._handlers = handlers;
    startAnimationMobile._initted = true;
  };

  // destroy
  startAnimationMobile.destroy = () => {
    if (!startAnimationMobile._initted) return;
    const h = startAnimationMobile._handlers || {};
    try {
      if (h.touchStart) canvas.removeEventListener("touchstart", h.touchStart);
      if (h.touchMove) canvas.removeEventListener("touchmove", h.touchMove);
      if (h.touchEnd) canvas.removeEventListener("touchend", h.touchEnd);
      if (h.touchCancel) canvas.removeEventListener("touchcancel", h.touchCancel);
      if (h.mouseDown) canvas.removeEventListener("mousedown", h.mouseDown);

      window.removeEventListener("mousemove", h.mouseMove);
      window.removeEventListener("mouseup", h.mouseUp);
      window.removeEventListener("resize", h.resize);
    } catch (e) {
      console.warn('[frames-debug] erro ao remover listeners mobile:', e);
    }

    startAnimationMobile._handlers = null;
    startAnimationMobile._initted = false;
  };

  // destroy: remove listeners e permite reinicializar
  startAnimationMobile.destroy = () => {
    if (!startAnimationMobile._initted) return;
    const h = startAnimationMobile._handlers || {};
    try {
      if (h.touchStart) canvas.removeEventListener("touchstart", h.touchStart);
      if (h.touchMove) canvas.removeEventListener("touchmove", h.touchMove);
      if (h.touchEnd) canvas.removeEventListener("touchend", h.touchEnd);
      if (h.touchCancel) canvas.removeEventListener("touchcancel", h.touchCancel);
      if (h.mouseDown) canvas.removeEventListener("mousedown", h.mouseDown);

      window.removeEventListener("mousemove", h.mouseMove);
      window.removeEventListener("mouseup", h.mouseUp);
      window.removeEventListener("resize", h.resize);
    } catch (e) {
      console.warn('[frames-debug] erro ao remover listeners mobile:', e);
    }

    startAnimationMobile._handlers = null;
    startAnimationMobile._initted = false;
  };

  // Animações imagens mobile
  function initMobileCanvasAnimation() {
    const informativesEl = document.querySelector('.informatives_wine--unique_wine-image');
    const canteenEl = document.querySelector('.canteen_about--unique_wine-image');

    if (!Array.isArray(imgs) || imgs.length === 0) {
      console.warn('[frames-debug] initMobileCanvasAnimation: nenhum frame disponível. Abortando.');
      return;
    }

    const createCanvasFor = (containerEl, opt = {}) => {
      if (!containerEl) return null;
      if (containerEl.dataset.mobileInit === '1') return containerEl._mobileCanvasApi || null;
      containerEl.dataset.mobileInit = '1';

      let localUrls = null;
      try {
        const da = containerEl.getAttribute('data-pictures-array');
        if (da) {
          localUrls = JSON.parse(da);
          if (!Array.isArray(localUrls)) localUrls = null;
        }
      } catch (err) {
        console.warn('[frames-debug] erro parseando data-pictures-array:', err);
        localUrls = null;
      }

      const preloadUrls = (urls) => {
        const promises = urls.map(url => new Promise(resolve => {
          const i = new Image();
          if (typeof url === 'string' && url.startsWith('//')) i.src = 'https:' + url;
          else i.src = url;
          i.onload = () => resolve({ img: i, ok: true });
          i.onerror = () => resolve({ img: i, ok: false });
        }));
        return Promise.all(promises).then(results => results.filter(r => r.ok).map(r => r.img));
      };

      const buildApiFromImgs = (sourceImgs) => {
        const existingImg = containerEl.querySelector('img');
        if (existingImg) existingImg.remove();

        const canvas = document.createElement('canvas');
        canvas.className = 'pictures_frames--mobile-canvas';
        canvas.style.display = 'block';
        if (opt.height) canvas.style.height = opt.height;
        if (opt.width) canvas.style.width = opt.width;
        if (opt.objectFit) canvas.style.objectFit = opt.objectFit;
        if (opt.minHeight) canvas.style.minHeight = opt.minHeight;
        if (opt.scale) canvas.style.scale = opt.scale;
        containerEl.appendChild(canvas);

        const ctx = canvas.getContext('2d');

        const api = {
          containerEl,
          canvas,
          ctx,
          frames: {
            currentIndex: 0,
            maxIndex: Math.max(0, sourceImgs.length - 1),
            imgs: sourceImgs
          },
          scaleDivisor: opt.scaleDivisor || 2.5,
          offsetDivisorX: opt.offsetDivisorX || 2,
          offsetDivisorY: opt.offsetDivisorY || 2,
          desiredFrame: 0,
          rafId: null,
          loadImage(index) {
            const framesObj = api.frames;
            if (!framesObj.imgs || framesObj.imgs.length === 0) return;
            index = Math.max(0, Math.min(framesObj.maxIndex, Math.floor(index)));
            const img = framesObj.imgs[index];
            if (!img || !img.naturalWidth) return;

            const rect = containerEl.getBoundingClientRect();
            const w = Math.max(1, Math.round(rect.width));
            const h = Math.max(1, Math.round(rect.height || (window.innerHeight * 0.5)));
            canvas.width = w * opt.widthMul;
            canvas.height = h * opt.heightMul;

            const scaleX = canvas.width / img.width;
            const scaleY = canvas.height / img.height;
            const scale = Math.max(scaleX, scaleY);

            const newWidth = (img.width * scale) / api.scaleDivisor;
            const newHeight = (img.height * scale) / api.scaleDivisor;

            const offsetX = (canvas.width - newWidth) / api.offsetDivisorX;
            const offsetY = (canvas.height - newHeight) / api.offsetDivisorY;

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
            ctx.drawImage(img, offsetX, offsetY, newWidth, newHeight);

            framesObj.currentIndex = index;
          },
          rafDraw() {
            api.rafId = null;
            const idx = Math.max(0, Math.min(api.frames.maxIndex, Math.floor(api.desiredFrame)));
            api.loadImage(idx);
          }
        };

        if (api.frames.imgs && api.frames.imgs.length > 0) {
          api.loadImage(0);
        } else {
          console.warn('[frames-debug] buildApiFromImgs: sem imagens válidas para', containerEl);
        }

        containerEl._mobileCanvasApi = api;
        return api;
      };

      if (Array.isArray(localUrls) && localUrls.length > 0) {
        return preloadUrls(localUrls).then(loadedImgs => {
          if (!loadedImgs || loadedImgs.length === 0) {
            console.warn('[frames-debug] todas as imagens locais falharam no preload — usando imgs global se existir.');
            if (Array.isArray(imgs) && imgs.length > 0) return buildApiFromImgs(imgs);
            return null;
          }

          return buildApiFromImgs(loadedImgs);
        }).catch(err => {
          console.warn('[frames-debug] erro no preloadUrls:', err);
          if (Array.isArray(imgs) && imgs.length > 0) return buildApiFromImgs(imgs);
          return null;
        });
      }

      if (Array.isArray(imgs) && imgs.length > 0) {
        return buildApiFromImgs(imgs);
      }

      return null;
    };

    const infoApi = createCanvasFor(informativesEl, {
      height: window.innerWidth > 768 ? '1400px' : (window.innerWidth > 550 ? '1200px' : '1000px'),
      scaleDivisor: 4,
      offsetDivisorX: 1.5,
      offsetDivisorY: 1.5,
      widthMul: 1,
      heightMul: 1,
    });

    const canteenApi = createCanvasFor(canteenEl, {
      height: window.innerWidth > 600 ? '100vw' : '100%',
      width: window.innerWidth > 600 ? '200px' : '100%',
      scaleDivisor: window.innerWidth > 600 ? 1.5 : 3,
      objectFit: window.innerWidth > 600 ? '' : 'cover',
      offsetDivisorX: 2,
      offsetDivisorY: 2,
      widthMul: 4,
      heightMul: window.innerWidth > 600 ? 4 : 7,
      scale: window.innerWidth > 600 ? 1 : 1.8,
    });

    if (!infoApi && !canteenApi) return;

    const makeTimeline = (opts) => {
      if (!opts.api || !opts.api.canvas) return null;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: opts.trigger,
          start: opts.start || 'top 90%',
          end: opts.end || 'top 30%',
          scrub: 1,
        }
      });

      // define o transform inicial, se fornecido
      if (opts.set) tl.set(opts.api.containerEl, opts.set);

      // add tweens for element props (like rotation, x)
      if (Array.isArray(opts.propTweens)) {
        opts.propTweens.forEach(pt => {
          tl.to(pt.target, pt.props, pt.label || 'a');
        });
      }

      // numeric tween to progress frames 0 -> max
      tl.to(opts.api.frames, {
        currentIndex: opts.api.frames.maxIndex,
        ease: 'none',
        immediateRender: false,
        onUpdate: () => {
          // atualiza desiredFrame e agenda draw do respectivo canvas
          opts.api.desiredFrame = opts.api.frames.currentIndex;
          if (!opts.api.rafId) opts.api.rafId = requestAnimationFrame(opts.api.rafDraw);
        }
      }, opts.framesLabel || 'a');

      return tl;
    };

    // informatives
    if (infoApi) {
      makeTimeline({
        api: infoApi,
        trigger: '.informatives_wine--container',
        start: 'top 90%',
        end: 'top 30%',
        scrub: 1,
        set: { transformOrigin: '50% 50%', rotation: 0 },
        propTweens: [{
          target: infoApi.containerEl,
          props: { rotation: -45, ease: 'none', willChange: 'transform' }
        }],
        framesLabel: 'a'
      });
    }

    // canteen
    if (canteenApi) {
      makeTimeline({
        api: canteenApi,
        trigger: '.canteen_about--container',
        start: 'top 90%',
        end: 'top 30%',
        scrub: 1,
        set: {
          rotation: window.innerWidth > 600 ? 270 : 320,
          stagger: 0.5,
          opacity: 0,
        },
        propTweens: [{
          target: canteenApi.containerEl,
          props: {
            opacity: 1,
            ease: 'none',
            willChange: 'transform'
          }
        }],
        framesLabel: 'c'
      });
    }

    // small refresh para garantir que ScrollTrigger recalcula com os canvas
    setTimeout(() => { if (window.ScrollTrigger) ScrollTrigger.refresh(); }, 60);

    // redesenha cada canvas no resize
    const onResize = () => {
      [infoApi, canteenApi].forEach(api => {
        if (api) api.loadImage(Math.floor(api.frames.currentIndex || 0));
      });
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    };
    window.addEventListener('resize', onResize);

    // cleanup antesunload
    window.addEventListener('beforeunload', () => {
      [infoApi, canteenApi].forEach(api => {
        if (api && api.rafId) cancelAnimationFrame(api.rafId);
      });
    });
  }

  // Animações dos textos e icones da tela do produto
  const activeTextTimelines = [];
  const activeSplitInstances = [];

  function clearTextAnimations() {
    // limpa timelines gsap guardadas
    while (activeTextTimelines.length) {
      const tl = activeTextTimelines.pop();
      try { tl.kill(); } catch (e) {
        console.log('Erro ao limpar timelines guardadas', e);
      }
    }

    // reverte SplitText (remove wrappers criados)
    while (activeSplitInstances.length) {
      const s = activeSplitInstances.pop();
      try {
        if (typeof s.revert === 'function') s.revert();
        else if (typeof s.revertLines === 'function') s.revertLines();

      } catch (e) {
        console.log('Erro ao reverter SplitText', e);
      }
    }

  }

  function initTextAnimations() {
    clearTextAnimations();

    // --- description static image (product) ---
    const DescriptionStaticImage = document.querySelector('.wine_description--static_wine-image');
    if (DescriptionStaticImage) {
      const tl_DescriptionStaticImage = gsap.timeline({
        scrollTrigger: {
          trigger: '#product--wine',
          start: 'top 70%',
          end: 'top 50%',
          scrub: 1
        },
      });
      tl_DescriptionStaticImage.from(DescriptionStaticImage, {
        opacity: 0,
        stagger: 0.15,
        y: 0,
        x: -100,
        ease: "none",
      }, 'a');

      activeTextTimelines.push(tl_DescriptionStaticImage);
    }

    // --- text_block_first ---
    const text_block_first = document.querySelector('.text-block--first span');
    if (text_block_first) {
      const splitTextBlockFirst = new SplitText(text_block_first, { type: "lines" });
      activeSplitInstances.push(splitTextBlockFirst);

      const tlFirst = gsap.from(splitTextBlockFirst.lines, {
        scrollTrigger: {
          trigger: text_block_first,
          start: "top 90%",
          end: "top 35%",
          scrub: 1,
        },
        opacity: 0,
        x: -50,
        stagger: 0.15,
        ease: "none"
      });

      activeTextTimelines.push(tlFirst);
    }

    // --- text_block_second ---
    const text_block_second = document.querySelector('.text-block--second span');
    if (text_block_second) {
      const splitTextBlockSecond = new SplitText(text_block_second, { type: "lines" });
      activeSplitInstances.push(splitTextBlockSecond);

      const tlSecond = gsap.from(splitTextBlockSecond.lines, {
        scrollTrigger: {
          trigger: text_block_second,
          start: "top 90%",
          end: "top 35%",
          scrub: 1,
        },
        opacity: 0,
        x: 50,
        stagger: 0.15,
        ease: "none"
      });
      activeTextTimelines.push(tlSecond);
    }

    // --- informatives icons & titles & info ---
    try {
      let tl_informatives_icons = gsap.timeline({
        scrollTrigger: {
          trigger: '.informatives_product--content',
          start: 'top 90%',
          end: 'top 15%',
          scrub: 1
        },
      });

      tl_informatives_icons
        .from('.informatives_icons--svg svg', {
          y: -50,
          opacity: 0,
          stagger: 0.15,
          ease: "none"
        }, 'a')
        .from('.informatives--card-title', {
          x: 150,
          opacity: 0,
          stagger: 0.15,
          ease: "none"
        }, 'a')
        .from('.informatives--card-info', {
          x: -50,
          opacity: 0,
          stagger: 0.15,
          ease: "none"
        }, 'a');

      activeTextTimelines.push(tl_informatives_icons);
    } catch (e) {
      console.warn('[frames-debug] falha ao init tl_informatives_icons:', e);
    }

    // --- informatives static image ---
    const informativesStaticImage = document.querySelector('.informatives_wine--static_wine-image');
    if (informativesStaticImage) {
      let tl_informativesStaticImage = gsap.timeline({
        scrollTrigger: {
          trigger: '.informatives_product--content',
          start: 'top 70%',
          end: 'top 50%',
          scrub: 1
        },
      });

      tl_informativesStaticImage.from(informativesStaticImage, {
        opacity: 0,
        stagger: 0.15,
        y: 0,
        ease: "none",
      }, 'a');

      activeTextTimelines.push(tl_informativesStaticImage);
    }

    // --- informatives wine characteristics ---
    const informativesWineCharacteristics = document.querySelectorAll('.informatives_wine--characteristics');
    if (informativesWineCharacteristics && informativesWineCharacteristics.length) {
      let tl_informatives_wine_characteristics_title = gsap.timeline({
        scrollTrigger: {
          trigger: '.informatives_wine--container',
          start: 'top 90%',
          end: 'top 15%',
          scrub: 1
        },
      });

      informativesWineCharacteristics.forEach(item => {
        const informativesTitles = item.querySelector('.informatives_wine--characteristics-title');
        const informativesDots = item.querySelectorAll('.informatives_wine--characteristics-dots .dot');

        if (informativesTitles) {
          const splitText = new SplitText(informativesTitles, { type: "lines" });
          activeSplitInstances.push(splitText);

          tl_informatives_wine_characteristics_title.from(splitText.lines, {
            x: -50,
            opacity: 0,
            stagger: 0.15,
            ease: "none",
            duration: 2,
          });
        }

        if (informativesDots && informativesDots.length) {
          informativesDots.forEach(dot => {
            tl_informatives_wine_characteristics_title.from(dot, {
              y: 50,
              opacity: 0,
              stagger: 0.15,
              ease: "none",
              duration: 2,
            });
          });
        }
      });

      activeTextTimelines.push(tl_informatives_wine_characteristics_title);
    }

    // --- informatives form buy (títulos, price, breadcrumb, compare, btn) ---
    const informativesWineFormBuy = document.querySelector('.informatives_wine--form-buy');
    if (informativesWineFormBuy) {
      const informativesFormTitle = informativesWineFormBuy.querySelector('.product__title');
      const informativesFormBreadcrumb = informativesWineFormBuy.querySelector('.breadcrumb_vedor');
      const informativesFormPrice = informativesWineFormBuy.querySelector('.product__price--regular');
      const informativesFormPriceCompare = informativesWineFormBuy.querySelector('.product__price--compare');
      const informativesFormBtn = informativesWineFormBuy.querySelector('.product__submit__holder');

      let tl_informatives_wine_form_buy = gsap.timeline({
        scrollTrigger: {
          trigger: '.informatives_product--container',
          start: 'top 30%',
          end: 'top 10%',
          scrub: 1
        },
      });

      if (informativesFormTitle) {
        const splitTextFormTitle = new SplitText(informativesFormTitle, { type: "lines" });
        activeSplitInstances.push(splitTextFormTitle);
        tl_informatives_wine_form_buy.from(splitTextFormTitle.lines, {
          x: -80,
          opacity: 0,
          stagger: 0.15,
          ease: "none",
        }, 'a');
      }

      if (informativesFormPrice) {
        const splitTextFormPrice = new SplitText(informativesFormPrice, { type: "lines" });
        activeSplitInstances.push(splitTextFormPrice);
        tl_informatives_wine_form_buy.from(splitTextFormPrice.lines, {
          y: -50,
          opacity: 0,
          stagger: 0.15,
          ease: "none",
        }, 'b');
      }

      if (informativesFormBreadcrumb) {
        const splitTextFormBreadcrumb = new SplitText(informativesFormBreadcrumb, { type: "lines" });
        activeSplitInstances.push(splitTextFormBreadcrumb);
        tl_informatives_wine_form_buy.from(splitTextFormBreadcrumb.lines, {
          x: 80,
          opacity: 0,
          stagger: 0.15,
          ease: "none",
        }, 'b');
      }

      if (informativesFormPriceCompare) {
        const splitTextFormPriceCompare = new SplitText(informativesFormPriceCompare, { type: "lines" });
        activeSplitInstances.push(splitTextFormPriceCompare);
        tl_informatives_wine_form_buy.from(splitTextFormPriceCompare.lines, {
          y: 50,
          opacity: 0,
          stagger: 0.15,
          ease: "none",
        }, 'b');
      }

      if (informativesFormBtn) {
        tl_informatives_wine_form_buy.from(informativesFormBtn, {
          width: 0,
          opacity: 0,
          stagger: 0.15,
          ease: "none",
        }, 'c');
      }

      activeTextTimelines.push(tl_informatives_wine_form_buy);
    }

    // --- canteen texts ---
    const canteenTextSubtitle = document.querySelector('.canteen_texts--subtitle');
    const canteenTextName = document.querySelector('.canteen_texts--name');
    const canteenTextDescription = document.querySelector('.canteen_texts--description');
    const canteenAboutStaticImage = document.querySelector('.canteen_about--static_wine-image');

    // Mobile: animações mais rápidas e começam mais cedo
    const isMobile = window.innerWidth < 850;
    const canteenScrollConfig = isMobile ? {
      trigger: '.canteen_about--texts',
      start: 'top 95%',
      end: 'top 70%',
      scrub: 0.5
    } : {
      trigger: '.canteen_about--texts',
      start: 'top 70%',
      end: 'top 20%',
      scrub: 1
    };

    let tl_canteenTexts = gsap.timeline({
      scrollTrigger: canteenScrollConfig,
    });

    if (canteenAboutStaticImage) {
      tl_canteenTexts.from(canteenAboutStaticImage, {
        opacity: 0,
        stagger: 0.15,
        x: isMobile ? 0 : -100,
        y: isMobile ? 30 : 0,
        ease: "none",
      }, 'a');
    }

    if (canteenTextName) {
      const splitCanteenName = new SplitText(canteenTextName, { type: "lines" });
      activeSplitInstances.push(splitCanteenName);
      tl_canteenTexts.from(splitCanteenName.lines, {
        opacity: 0,
        stagger: 0.15,
        ease: "none",
        x: isMobile ? 0 : 150,
        y: isMobile ? 20 : 0
      }, 'a');
    }

    if (canteenTextSubtitle) {
      const splitCanteenSubtitle = new SplitText(canteenTextSubtitle, { type: "lines" });
      activeSplitInstances.push(splitCanteenSubtitle);
      tl_canteenTexts.from(splitCanteenSubtitle.lines, {
        opacity: 0,
        stagger: 0.15,
        ease: "none",
        x: isMobile ? 0 : -150,
        y: isMobile ? 20 : 0
      }, 'b');
    }

    if (canteenTextDescription) {
      const splitCanteenDescription = new SplitText(canteenTextDescription, { type: "lines" });
      activeSplitInstances.push(splitCanteenDescription);
      tl_canteenTexts.from(splitCanteenDescription.lines, {
        opacity: 0,
        stagger: 0.1,
        ease: "none",
        x: isMobile ? 0 : -150,
        y: isMobile ? 15 : 0
      }, 'b');
    }

    activeTextTimelines.push(tl_canteenTexts);

    // garantir que ScrollTrigger recalcule posições
    if (window.ScrollTrigger && typeof ScrollTrigger.refresh === 'function') {
      setTimeout(() => {
        try {
          ScrollTrigger.refresh();
        } catch (e) {
          console.log('Erro ao recalcular', e)
        }
      }, 40);
    }
  }

  // --- Observer para recarregar animações ao mudar width/height ---
  const debounce = (fn, wait = 120) => {
    let t = null;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  let lastW = window.innerWidth;
  let lastH = window.innerHeight;

  const cleanupScrollTriggers = () => {
    if (window.ScrollTrigger && typeof ScrollTrigger.getAll === 'function') {
      // evita duplicação
      const all = ScrollTrigger.getAll();
      all.forEach(st => {
        try {
          st.kill(true);
        } catch (e) {
          console.log('Erro ao limpar scroll trigger', e)
        }
      });
    }
  };

  const cleanupGsapTweens = () => {
    try {
      // limpa tweens que animam o canvas e o objeto frames
      gsap.killTweensOf(".pictures_frames--canvas");
      gsap.killTweensOf(frames);
      gsap.killTweensOf(window);
    } catch (e) {
      console.log('Erro ao limpar tweens', e)
    }
  };

  const reinitAnimations = (opts = {}) => {
    const w = window.innerWidth;
    const h = window.innerHeight;

    // só reinit se realmente mudou dimensões
    if (!opts.force && w === lastW && h === lastH) return;

    lastW = w; lastH = h;

    // cleanup
    cleanupGsapTweens();
    cleanupScrollTriggers();
    initTextAnimations();

    // redraw do canvas atual (garante que não fique vazio)
    loadImage(Math.floor(frames.currentIndex));

    // decide qual animação iniciar
    if ((opts.forceMobile || w < 1080) && typeof startAnimationMobile === 'function') {
      // mobile
      try {
        if (typeof startAnimationMobile.destroy === 'function') startAnimationMobile.destroy();
        startAnimationMobile();
        if (typeof initMobileCanvasAnimation === 'function') initMobileCanvasAnimation();
      } catch (e) {
        console.warn('[frames-debug] erro ao iniciar animação mobile:', e);
      }
    } else {
      // se for desktop, limpa listeners mobile existentes
      try {
        if (typeof startAnimationMobile.destroy === 'function') startAnimationMobile.destroy();
      } catch (e) {
        console.log('Erro ao limpar listeners mobile', e)
      }

      if ((opts.forceDesktop || w >= 1080) && typeof startAnimation === 'function') {
        try {
          startAnimation();
        } catch (e) {
          console.warn('[frames-debug] erro ao iniciar animação desktop:', e);
        }
      }
    }
  };

  const debouncedReinit = debounce(reinitAnimations, 160);

  // ResizeObserver para mudanças de layout
  if (window.ResizeObserver) {
    const ro = new ResizeObserver(entries => {
      // pega dimensões mais recentes do viewport
      debouncedReinit();
    });

    // observa raiz do documento
    ro.observe(document.documentElement);

    // observa canvas pai
    if (canvas && canvas.parentElement) {
      ro.observe(canvas.parentElement);
    }

    // fallback: ouvinte de resize para navegadores sem ResizeObserver
  } else {
    window.addEventListener('resize', debouncedReinit);
    window.addEventListener('orientationchange', debouncedReinit);
  }

  if (!picturesArray.length) {
    frames.maxIndex = 0;

    // inicializa textos / animações
    if (typeof reinitAnimations === 'function') reinitAnimations({ force: true });
    else if (typeof initTextAnimations === 'function') initTextAnimations();
  }

  if (picturesArray.length) {
    preloadImages();
  }

  // Indicador de scroll - esconde ao rolar e ação de clique
  function initScrollIndicator() {
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (!scrollIndicator) return;

    let scrollIndicatorHidden = false;

    // Ação de clique para descer a tela
    scrollIndicator.addEventListener('click', function () {
      // Rola 1 tela para baixo ou até o próximo elemento
      window.scrollBy({
        top: window.innerHeight * 0.8,
        behavior: 'smooth'
      });

      // Esconde imediatamente após o clique para evitar flicker
      scrollIndicator.classList.add('hidden');
      scrollIndicatorHidden = true;
    });

    const hideScrollIndicator = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (scrollTop > 10 && !scrollIndicatorHidden) {
        scrollIndicator.classList.add('hidden');
        scrollIndicatorHidden = true;
      } else if (scrollTop <= 10 && scrollIndicatorHidden) {
        scrollIndicator.classList.remove('hidden');
        scrollIndicatorHidden = false;
      }
    };

    window.addEventListener('scroll', hideScrollIndicator, { passive: true });
    hideScrollIndicator(); // Verifica estado inicial
  }

  // Tenta iniciar imediatamente e também observa caso o elemento entre depois
  initScrollIndicator();
  // Fallback caso o DOM não esteja 100% pronto no momento da execução
  setTimeout(initScrollIndicator, 500);

})